// Zendesk Chat Custom Integration

zE("messenger:on", "close", function () {  
  sessionStorage.setItem('zendeskChatStatus', 'closed');
})

zE('messenger:on', 'open', function() {    
    sessionStorage.setItem('zendeskChatStatus', 'open');
});

const ll_zendeskUnreadIndicator = document.querySelector('#chatresponse');

const ll_resetUnreadIndicator = () => {
  ll_zendeskUnreadIndicator.style.display = 'none';
  ll_zendeskUnreadIndicator.innerHTML = 0;
}

const ll_populateUnreadIndicator = (count) => {
  if (!count) return ll_resetUnreadIndicator();
  ll_zendeskUnreadIndicator.style.display = 'block';
  ll_zendeskUnreadIndicator.innerHTML = count;
}

function ll_checkZendeskUnreadMessages() {
  zE('messenger:on', 'unreadMessages', (count) => {
    ll_populateUnreadIndicator(count);
  });
}
window.onload = function() {
  ll_checkZendeskUnreadMessages();
};
document.getElementById("zendesklivechat").addEventListener("click", function() {
  zE('messenger', 'open');
  ll_resetUnreadIndicator();
});

ll_zendeskUnreadIndicator.addEventListener("click", function() {
  zE('messenger', 'open');
  ll_resetUnreadIndicator();
});

if (sessionStorage.getItem("ZD-widgetOpen")) {
  zE('messenger', 'open');
  ll_resetUnreadIndicator();
}

// Show and hide Help-Center-Bubble
const clickableIds = ["Help-Center", "Help-Center-PDP"];

function hideHelpCenter() {
  document.getElementById("Help-Center").style.display = 'none';
}

function eventGTM(buttonName) {  
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': buttonName + '_clicked',
  });
}

clickableIds.forEach(id => {
  const element = document.getElementById(id);
  if (element) {
    element.addEventListener("click", hideHelpCenter);
    element.addEventListener("click", function() {
      eventGTM(id);
    });
  }
});

var targetNode = document.getElementById("SupportDrawer");
var observerOptions = {
  attributes: true,
  attributeFilter: ['class']
};

var observerCallback = function(mutationsList) {
  for (var mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      var classList = mutation.target.classList;
      if (!classList.contains('show-close-cursor')) {
        document.getElementById("Help-Center").style.display = 'block';
      }
    }
  }
};

var observer = new MutationObserver(observerCallback);
observer.observe(targetNode, observerOptions);

//Hide SupportDrawer by click on zendesklivechat
function showHelpCenter() {
  document.getElementById("Help-Center").style.display = 'block';
  document.getElementById("SupportDrawer").style.visibility = 'hidden';
  document.getElementById("SupportDrawer").style.opacity = 0;
  document.getElementById("SupportDrawer").classList.remove('show-close-cursor');
  document.getElementById("SupportDrawer").removeAttribute('open');
}

const zendeskLiveChat = document.getElementById("zendesklivechat");
if (zendeskLiveChat) {
  zendeskLiveChat.addEventListener("click", showHelpCenter);
}